import { useState } from 'react';

import { BaseUrlTaxpayer } from '@/app/modules/taxes/services/tax.service';

import { useGetApplication } from '../../hooks';
import { type OmissionsPaymentsByTax, type StatisticsRequest } from '../Collections/types';

import { type ComplianceStatistics, type OmissionsByTax } from './types';

export const useGetNonComplianceTaxpayer = (taxpayerId: string) => {
  const [state] = useState({});
  const id = taxpayerId ? taxpayerId : 'c2669cec-d7d3-479e-906e-479733354628';

  return useGetApplication<Array<OmissionsByTax>>({
    url: `${BaseUrlTaxpayer}/${id}/non-compliances`,
    params: state
  });
};

export const useGetNonCompliancePaymentTaxpayer = (taxpayerId: string) => {
  const [state] = useState({});
  const id = taxpayerId ? taxpayerId : 'c2669cec-d7d3-479e-906e-479733354628';

  return useGetApplication<Array<OmissionsPaymentsByTax>>({
    url: `${BaseUrlTaxpayer}/${id}/non-compliances-payments`,
    params: state
  });
};

export const useGetComplianceStatistics = (request: StatisticsRequest) => {
  const result = useGetApplication<ComplianceStatistics>({
    url: `NonCompliances/statistics`,
    params: request
  });
  return result;
};
